import { useMemo } from 'react';

import { FileServiceProviderConfig } from '@work4all/models/lib/Classes/FileServiceProviderConfig.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useFileServiceProviderConfigRequestData = (
  id: string | number
) => {
  return useMemo<DataRequest>(() => {
    const fileServiceProviderConfigRequestData: FileServiceProviderConfig<EMode.query> =
      {
        id: null,
        name: null,
        directoryConvertPaths: null,
        isWorkDirectory: null,
        providerType: null,
        config: {
          oneDriveFspConfig: {
            clientId: null,
            clientSecret: null,
            driveId: null,
            siteId: null,
            tenantId: null,
          },
          webDavFspConfig: {
            address: null,
            password: null,
            username: null,
          },
        },
      };
    const filter = [{ id: { $eq: id } }];
    const data = fileServiceProviderConfigRequestData;
    return {
      entity: Entities.fileServiceProviderConfig,
      data,
      filter,
      completeDataResponse: true,
    };
  }, [id]);
};
